import {useCreateRentalImageGetUrlMutation} from '../../../generated/graphql'
import {useEffect} from 'react'

export const useImageUrl = (id: string) => {
  const [createImageGetUrl, {data, error, loading}] = useCreateRentalImageGetUrlMutation({
    variables: {id},
    fetchPolicy: 'no-cache',
    errorPolicy: 'all',
    notifyOnNetworkStatusChange: true,
  })

  useEffect(() => {
    createImageGetUrl()
  }, [createImageGetUrl, id])

  return {
    createImageGetUrl,
    loading,
    imageUrl: data?.createRentalImageGetUrl?.imageUrl ?? undefined,
    error,
  }
}
